const VERSION_KEY = 'app_version';

import { doc, getDoc } from 'firebase/firestore';
import { firestore } from '../lib/firebase/config';

export const checkVersion = async () => {
  try {
    // Get version from Firestore
    const versionRef = doc(firestore, 'version', 'version');
    const versionDoc = await getDoc(versionRef);
    
    if (!versionDoc.exists()) {
      console.warn('Version document not found in Firestore');
      return;
    }

    const firestoreVersion = versionDoc.data().version;
    const storedVersion = localStorage.getItem(VERSION_KEY);
    
    if (!storedVersion || storedVersion !== firestoreVersion) {
      // Clear cache
      if ('caches' in window) {
        const cacheKeys = await caches.keys();
        await Promise.all(
          cacheKeys.map(key => caches.delete(key))
        );
      }
      
      // Update stored version
      localStorage.setItem(VERSION_KEY, firestoreVersion);
      
      // Dispatch custom event for version change
      window.dispatchEvent(new CustomEvent('sw-new-version'));
    }
  } catch (error) {
    console.error('Error checking version:', error);
  }
};